//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { EventBus } from './../../events.js';
    import EmojiPicker from 'vue-emoji-picker';

	export default {
		name: "comment",
		//props: ['comment', 'response', 'indexComment', 'list'],
    props: {
        comment: Object,
        response: Boolean,
        indexComment: Number,
        list: Boolean,
        commentType: String,
        canUseComments: Boolean
    },
    components: {EmojiPicker},
		data() {
			return {
				active: true,
				editable: false,
				editabletext: '',
				editInProgress: false,

				editFormEnabled: false,
				responseFormEnabled: false,
        responseInProgress: false,

				alertFormEnabled: false,

				user: Object,
				reply: new window.Form({
					body: '',
					article_id: '',
					parent_id: '',
                    game_id: '',
				}),
				alert: new window.Form({
					user_comment: '',
					signalment_type_id: 5,
				}),
				update: new window.Form({
					body: '',
				}),
        searchEmoji: '',

        canView: true,
        canDelete: false,
        canEdit: false,
        canModerate: false,
        canAlert: false,
        canBlock: false,
        canStaffDelete: false,
        canValidate: false,
			}
		},
		/*
        updated() {
            let element = this.getCommentElement();

            if( element.tagName === 'TEXTAREA' ) {
                element.value = this.editableText.trim();
                element.innerText = this.editabletext.trim;
            }
        },
        */
        mounted() {
            //this.user = User;
            setTimeout(() => {
                this.user = this.$root.user;

                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });

                this.checkCapabilities();

            }, 1000);


		    let updateBody = this.comment.body;
		    updateBody = updateBody.replace('<br />', "\n");
			this.update.body = updateBody;

            setTimeout(() => {
                $('.lazy-logo').Lazy();
            }, 2000);
        },
		methods: {
      checkCapabilities() {
        console.log(this.comment.validation);
          this.editable = this.comment.editable;
          this.canEdit = this.user.isConnected && this.comment.editable && (this.user.id == parseFloat(this.comment.user_id)) && this.comment.validation !== 3;
          this.canDelete = this.user.isConnected && this.comment.editable && ((this.user.id == parseFloat(this.comment.user_id))) && this.comment.validation !== 3;
          this.canModerate = this.user.isConnected && this.user.isStaff && this.comment.validation < 2 && ((this.user.id !== parseFloat(this.comment.user_id)));
          this.canAlert = this.user.isConnected && parseFloat(this.comment.validation) != 3 && parseFloat(this.comment.validation) !== 2 && !this.user.isStaff && parseFloat(this.comment.user_id) !== this.user.id;
          this.canBlock = this.user.isConnected && this.user.id != parseFloat(this.comment.user_id) && ((this.user.id != parseFloat(this.comment.user_id)));
          this.canStaffDelete = this.user.isConnected && this.user.isStaff && this.comment.validation < 2  && ((this.user.id != parseFloat(this.comment.user_id)));
          this.canView = this.user.isConnected && (parseFloat(this.comment.validation) == 2 && (this.user.isStaff || this.user.id == parseFloat(this.comment.user_id) ) || parseFloat(this.comment.validation) != 2) ;
          this.canValidate = this.user.isConnected && parseFloat(this.comment.validation) == 2 && this.user.isStaff;
      },

			/**
			 * Like d'un commentaire
			 */
			like() {
				if( this.user.id === this.comment.user.id ) {
				    window.Notify.error('Vous ne pouvez pas aimer vos propres commentaires.');
				} else {
					EventBus.$emit('liked', {
						comment: this.comment,
						index: this.indexComment,
					});
				}
			},

            appendEmojiToResponse(emoji) {
                this.reply.body += ' ' + emoji;
            },

            translateEmoji(str) {
                str = str.replace('Frequently used', 'Fréquemment utilisés');
                str = str.replace('People', 'Personnes');
                str = str.replace('Objects', 'Objets');
                str = str.replace('Places', 'Lieux');
                str = str.replace('Symbols', 'Symboles');
                return str;
            },

			/**
			 * Suppression d'un commentaire
			 */
			deleteComment() {
				if( this.editInProgress ) {
				    window.Notify.warning('Vous êtes en train de modifier votre commentaire, êtes vous sûr de vouloir le supprimer ?');
                }

				if( this.user.isStaff || this.user.id === this.comment.user.id ) {
					this.active = false;

					window.Api.delete('comments/' + this.comment.id).then(response => {
						if( response.success ) {
							if( typeof response.data !== 'undefined' ) {

								if( response.data.comment.author !== this.comment.author ) {
									this.$parent.comments[this.indexComment].user_id = null;
									this.$parent.comments[this.indexComment].author = response.data.comment.author;
								}

								this.$parent.comments[this.indexComment].body = response.data.comment.body;
								this.$parent.comments[this.indexComment].updated = null;
							} else {
								EventBus.$emit('deleted', {
									id: this.comment.id,
									index: this.indexComment,
								});
								window.Notify.success(response.message);
							}
						} else {
							window.Notify.error(response.message);
						}
					});
				} else {
					window.Notify.error('Vous ne pouvez supprimer un commentaire qui ne vous appartient pas.');
				}
				this.active = true;
			},

			/**
			 * Modération d'un commentaire
			 */
			moderate() {
				if( this.user.isStaff || this.user.isModerator ) {
					window.Api.get('comments/' + this.comment.id + '/moderate?index=' + this.indexComment).then((response) => {
						if( response.success ) {
							this.$parent.comments[this.indexComment].body = response.data.comment.body;
						} else {
							window.Notify.error(response.message);
						}
					});
				} else {
					window.Notify.error('Vous n\'avez pas les droits nécessaires pour modérer un commentaire.')
				}
			},

      validate() {
        if( this.user.isStaff ) {
          window.Api.get('comments/' + this.comment.id + '/validate?index=' + this.indexComment).then((response) => {
            if( response.success ) {
              this.$parent.comments[this.indexComment].body = response.data.comment.body;
              this.$parent.comments[this.indexComment].validation = parseFloat(response.data.comment.validation);
              this.canValidate = false;
              this.canStaffDelete = true;
              this.canModerate = true;
            } else {
              window.Notify.error(response.message);
            }
          });
        } else {
          window.Notify.error('Vous n\'avez pas les droits nécessaires pour valider un commentaire.')
        }
      },

            block() {
			    window.Api.get('comments/' + this.comment.user.id + '/block').then((response) => {
			        if( response.success ) {
			            window.Notify.success(response.message);
			            this.$parent.comments.forEach((comment, index) => {
			               if( comment.user_id === response.data.blocked ) {
                                this.$parent.comments.splice(index, 1);
                           }
                        });
                    } else {
                        window.Notify.error(response.message);
                    }
                });
            },

			sendResponse() {
				this.reply.parent_id = this.comment.id;
				this.reply.article_id = this.comment.article_id;
				this.reply.game_id = this.comment.game_id;
				this.responseInProgress = true;
				this.reply.post('api/comments').then(response => {
					if( response.success ) {
						this.displayResponseForm();
						//this.comment.replies.unshift(response.data.comment);
						//this.$parent.comments.splice(this.indexComment + 1, 0, response.data.comment);
                        EventBus.$emit('commentAnswered', {
                        	index: this.indexComment,
                            comment: response.data.comment
                        });
                        this.reply.reset();
					} else {
						window.Notify.error(response.message);
					}
					this.responseInProgress = false;
				});
			},

			sendUpdate() {
				this.update.put('api/comments/' + this.comment.id).then((response) => {
					if( response.success ) {
						let comment = response.data.comment;
						this.$parent.comments[this.indexComment].body = comment.body;
						this.$parent.comments[this.indexComment].updated = comment.updated;
						this.$parent.comments[this.indexComment].editable = comment.editable;

						this.displayEditableForm();
					} else {
						window.Notify.error(response.message);
					}
				});
			},

			sendAlert() {
				this.alert.post('api/comments/' + this.comment.id + '/alert').then(response => {
					if( response.success ) {
						window.Notify.success(response.message);
					} else {
						window.Notify.error(response.message);
						setTimeout(() => {
							window.location = 'https://secure.lerugbynistere.fr/nous-alerter/';
                        }, 2000);
					}
				});
			},

			displayAlertForm() {
				//console.log(this.user.isConnected);
				if( this.user.isConnected ) {
					this.responseFormEnabled = false;
					this.alertFormEnabled = !this.alertFormEnabled;
				} else {
					window.location = 'https://secure.lerugbynistere.fr/nous-alerter/';
                }
			},

			displayEditableForm() {
				if( this.user.isConnected && this.user.id === parseFloat(this.comment.user.id) ) {
					this.editable = !this.editable;
					this.editInProgress = !this.editInProgress;
					this.editFormEnabled = !this.editFormEnabled;

					if( this.editable ) {
					    let updateBody = this.comment.body;
                        updateBody = updateBody.replace(/<br *\/?>/gi, "\n");
						this.update.body = updateBody;
					}
				}
			},

			displayResponseForm() {
				this.alertFormEnabled = false;
				this.responseFormEnabled = !this.responseFormEnabled;
			},

			toogleEditable() {
				let element = this.getCommentElement();

				this.editable = !this.editable;
				this.editInProgress = !this.editInProgress;
				this.editableText = element.tagName === 'TEXTAREA' ? element.value : element.innerText;
			},

			getCommentElement() {
				return this.$refs.editableCom ? this.$refs.editableCom : this.$refs.commentBody;
			}
		},
		filters: {
			replaceTags(value) {
				return value.replace(/<br\s*[\/]?>/gi, "\n");
			}
		},
	}
